module.exports = __webpack_public_path__ + "static/media/menu_manageServices_default.18a973c0.svg";